// src/slices/productstore/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const getProductStoreData = createAsyncThunk("productStoreData/getAll", async (params = {}, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${API_URL}/product-store/all`, { params });
    return response;
  } catch (err) {

    return rejectWithValue(err.response?.data || { message: "Something went wrong" });
  }
});

export const getProductBySlug = createAsyncThunk("productStoreData/getBySlug", async (identifier, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${API_URL}/product-store/one`, { params: { identifier } });


    return response.data;
  } catch (err) {

    return rejectWithValue(err.response?.data || { message: "Something went wrong" });
  }
});
